// extracted by mini-css-extract-plugin
export var button = "lets-talk-section-module--button--M5mLo";
export var buttonWithLink = "lets-talk-section-module--button-with-link--Zl3Kz";
export var descriptionContainer = "lets-talk-section-module--description-container--Nb-fy";
export var firstRow = "lets-talk-section-module--first-row--vfPLm";
export var imageContainer = "lets-talk-section-module--image-container--dT5i8";
export var imageOnLeft = "lets-talk-section-module--image-on-left--jBO3s";
export var imageOnRight = "lets-talk-section-module--image-on-right--wUDac";
export var innerContainer = "lets-talk-section-module--inner-container--gsSgR";
export var innerWrapper = "lets-talk-section-module--inner-wrapper--AzQ3p";
export var outerWrapper = "lets-talk-section-module--outer-wrapper--SmZy7";
export var regularFont = "lets-talk-section-module--regular-font--32F-8";
export var title = "lets-talk-section-module--title--S9WX4";